
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-transcription",
      function () {
        return require("private-next-pages/ai-transcription/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-transcription"])
      });
    }
  